<!-- default router link -->
<a *ngIf="routerLink && routerLink.indexOf('http') == -1" class="button {{class}}" [ngStyle]="style">
  {{title}}
</a>

<!-- external router link -->
<a *ngIf="routerLink && routerLink.indexOf('http') != -1" href="{{routerLink}}" target="{{target}}" class="button {{class}}" [ngStyle]="style">
  {{title}}
</a>

<!-- custom event -->
<span *ngIf="!url && !routerLink && !configLink" class="button {{class}}" [ngStyle]="style" (click)="clickOnButton($event)">
    {{title}}
</span>

<!-- url -->
<a *ngIf="url && !routerLink" href="{{url}}" target="{{target}}" class="button {{class}}" [ngStyle]="style">
  {{title}}
</a>


<a *ngIf="!url && !routerLink && configLink" [href]="configLink" target="_blank" class="button text-center {{class}}" [ngStyle]="style">
  {{title}}
</a>
